# TODO: Fork leaflet so we can make improvements there
SimplifyOperation = App.load('core::leaflet/SimplifyOperation')



iterateLayers = (layer, callback = -> undefined) ->
    if layer.feature?
        callback(layer)
    else if layer.eachLayer?
        layer.eachLayer (l) ->
            iterateLayers(l, callback)


L.FeatureGroup.prototype.recursiveEachLayer = (callback = -> undefined) ->
    iterateLayers(this, callback)

###

# Clone Geometry methods.
# this covers all the cases we are using (where we need cloning).
# If people try cloning and it fails.. welll.... you should stop.
# Or write cloneGeom methods for whatever weird geometry you are
# trying to clone

###

L.LatLng.prototype.cloneGeom = () ->
    geom = new L.LatLng @lat, @lng
    if @_cloneProperties?
        geom._cloneProperties = $.extend {}, @_cloneProperties

    return geom


L.Polygon.prototype.cloneGeom = () ->
    newpath = []

    for i in @_latlngs
        newpath.push i.cloneGeom()

    newpoly = new L.Polygon(newpath, @options)
    newpoly._holes = []

    newpoly.isValid = @isValid ? true

    if @_holes?
        for hole in @_holes
            holearr = []
            for i in hole
                holearr.push i.cloneGeom()

            newpoly._holes.push holearr

    if @_cloneProperties?
        newpoly._cloneProperties = $.extend {}, @_cloneProperties


    return newpoly

L.FeatureGroup.prototype.cloneGeom = () ->
    newfg = new L.FeatureGroup([])

    @eachLayer (l) ->
        if l.cloneGeom?
            newfg.addLayer l.cloneGeom()
        else
            console.log "Tried to cloneGeom on layer that doesn't have it:"
            console.log l

    if @_cloneProperties?
        newfg._cloneProperties = $.extend {}, @_cloneProperties

    return newfg


###

# Little hack for polygon
# Makes it so we can iterate over every point (including holes)
# of the polygon

###
L.Polygon.prototype.eachPoint = (cb) ->
    for v, i in @_latlngs
        cb.apply(this, [i, v])

    if @_holes?
        for hole in @_holes
            for v, i in hole
                cb.apply(this, [i, v])

L.FeatureGroup.prototype.simplify = (tolerance) ->
    @eachLayer (l) ->
        l.simplify(tolerance) if l.simplify?

L.FeatureGroup.prototype.cleanUp = () ->
    @eachLayer (l) =>
        if l instanceof L.Polygon
            if l._latlngs.length < 3
                @removeLayer l

        l.cleanUp() if l.cleanUp?


L.Polygon.prototype.rotate = (angle, center = null) ->
    if not center?
        center = @getBounds().getCenter()

    L.GeoUtil.rotatePoints(center, angle, @_latlngs)

    if @_holes?
        for i, ind in @_holes
            L.GeoUtil.rotatePoints(center, i)

    @redraw()


L.Draw.NewPoly = L.Draw.Polygon.extend({
    _getTooltipText: () ->
        text = ''
        subtext = ''

        if @_markers?.length is 0
            text = L.drawLocal.draw.handlers.polygon.tooltip.start
        else if @_markers?.length < 3
            text = L.drawLocal.draw.handlers.polygon.tooltip.cont
            subtext = @_getMeasurementString()
        else
            text = 'Click the blue dot to close the shape.'

        return { text, subtext }

    # extend the _finishShape method to prevent self-intersections when completing polygon
    _finishShape: () ->
        # get the existing latlng vertices
        latlngs = @_poly.getLatLngs()

        # we only do this check if we have more than 2 points
        # the default _finishShape handles the case of 1 or 2 points
        if latlngs.length > 2
            # add the first point to the end of the array, closing the polygon
            latlngs.push(latlngs[0])

            # convert the latlngs to layer points for turf to use
            points = latlngs.map((latlng) =>
                point = @_map.latLngToLayerPoint(latlng)
                return [point.x, point.y]
            )

            # use turf.kinks to check for self-intersection of complete polygon
            polygon = turf.polygon([points])
            kinks = turf.kinks(polygon)

            # remove the point we added to the latlngs array
            latlngs.pop()

            # if we have any self-intersections, prevent the polygon from being closed
            if kinks.features.length > 0
                @_showErrorTooltip()
                return

        # proceed with the default "Finish Shape" handling
        L.Draw.Polygon.prototype._finishShape.call(this)

    # if we're adding a vertex, make sure it's not at the same point as the previous vertex
    # this could be the case if the user double clicks the map to add a vertex
    addVertex: (latLng) ->
        # this can only happen if we already have a point
        if @_markers.length > 0
            previousLatLng = @_markers[@_markers.length - 1].getLatLng()

            # if this latLng is the same as the previous one, don't add the vertex
            if latLng.lat is previousLatLng.lat and latLng.lng is previousLatLng.lng
                return

        # proceed with the default "Add Vertex" handling
        L.Draw.Polygon.prototype.addVertex.call(this, latLng)

    # override the updateFinishHandler to prevent double clicking a spot from finishing a polygon
    # It looks like this functionality was built in to Leaflet Draw's Polygon, but was never accessible
    # because double clicking would always stack multiple vertices / markers on top of each other, instead of
    # triggering the last marker's double click event
    _updateFinishHandler: () ->
        # This is pulled directly from Leaflet Draw, except without the double click event
        markerCount = @_markers.length

        # The first marker should have a click handler to close the polygon
        if markerCount is 1
            @_markers[0].on('click', @_finishShape, this)
})



L.Draw.CustomRectangle = L.Draw.Rectangle.extend({
    _hasAncestor: (el, cls) =>
        # iterate through parent elements and try to find the one we want
        while not el.classList.contains(cls)
            # do nothing
            el = el.parentElement

            if not el
                break

        return el

    _onMouseUp: (e) ->
        if not @_shape and not @_isCurrentlyTwoClickDrawing
            @_isCurrentlyTwoClickDrawing = true
            # L.Draw.SimpleShape.prototype._onMouseUp.call(this)
            return

        if @_isCurrentlyTwoClickDrawing and not @_hasAncestor(e.target, 'leaflet-map-pane')
            return

        if @_shape
            L.Draw.SimpleShape.prototype._onMouseUp.call(this)

    _getTooltipText: () ->
        tooltipText = L.Draw.SimpleShape.prototype._getTooltipText.call(this)
        shape = @_shape
        showArea = @options.showArea

        if shape
            latLngs = if @_shape._defaultShape then @_shape._defaultShape() else @_shape.getLatLngs()
            area = L.GeometryUtil.geodesicArea(latLngs)
            subtext = if showArea then L.GeometryUtil.readableArea(area, @options.metric) else ''

        return {
            text: if @_isCurrentlyTwoClickDrawing then 'Click again to finish drawing' else tooltipText.text,
            subtext: subtext
        }
})